export const PARENT_MINI_TASK_STUDENT_HINT_KEY = 'parent_mini_tasks_student_hint';
